import styled from 'styled-components';

export default styled.div`
  grid-area: location;
  padding: 0 0 1rem 1rem;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
`;
